import awsExports from "../aws-exports";
import { fetchAuthSession } from "aws-amplify/auth";

const API_NAME = "adminusersapi";

function getAdminApiBaseUrl() {
  const api = awsExports.aws_cloud_logic_custom?.find(
    (item) => item.name === API_NAME
  );

  if (!api?.endpoint) {
    throw new Error(`API endpoint not found for ${API_NAME}`);
  }

  return api.endpoint.replace(/\/$/, "");
}

async function getIdToken() {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken?.toString();

  if (!idToken) {
    throw new Error("No authenticated session");
  }

  return idToken;
}

async function request(path, method, body) {
  const idToken = await getIdToken();
  const baseUrl = getAdminApiBaseUrl();

  const response = await fetch(`${baseUrl}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      "X-Id-Token": idToken,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const text = await response.text();

  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { raw: text };
  }

  if (!response.ok) {
    throw new Error(data.message || `Request failed with status ${response.status}`);
  }

  return data;
}

export function createCognitoUser(payload) {
  const safePayload = {
    username: payload?.username,
    email: payload?.email,
    role: payload?.role,
    ...(payload?.name ? { name: payload.name } : {}),
    ...(payload?.suppressEmail !== undefined ? { suppressEmail: payload.suppressEmail } : {}),
  };

  return request("/admin/users/create", "POST", safePayload);
}

export function updateCognitoUser(payload) {
  return request("/admin/users/update", "PUT", payload);
}

export function deleteCognitoUser(payload) {
  const username = encodeURIComponent(payload.username);
  return request(`/admin/users/delete?username=${username}`, "DELETE");
}

export function resetUserMfa(payload) {
  return request("/admin/users/reset-mfa", "PUT", payload);
}

export function getCognitoUser(username) {
  const encodedUsername = encodeURIComponent(username);
  return request(`/admin/users/get?username=${encodedUsername}`, "GET");
}
